// Location kinds (locations.type). A `private_warehouse` behaves exactly like
// a `warehouse` inside its own tenant; super admin can also share it with other
// tenants' store locations. Other tenants' private warehouses never appear in
// this tenant's location list.
export type LocationType = 'company' | 'warehouse' | 'private_warehouse';

export function isWarehouseType(type: string | null | undefined): boolean {
  return type === 'warehouse' || type === 'private_warehouse';
}

export function locationTypeLabel(type: string | null | undefined): string {
  if (type === 'private_warehouse') return 'Private Warehouse';
  if (type === 'warehouse') return 'Warehouse';
  return 'Store';
}
